<template>
	<v-card>
		<!-- <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs> -->
		
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 260px;" class="mr-1">
								<v-select :items="selectCourseList" v-model="query.courseId" item-text="courseName"
									item-value="id" label="课程" dense outlined clearable></v-select>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-text-field v-model="query.studentNo" label="学号" dense outlined></v-text-field>
							</div>
							
							<studentSearchBox @inputValue="setInputValue"></studentSearchBox>
							<div style="width: 200px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="状态" dense outlined></v-select>
							</div>
							<div style="width: 300px;" class="mr-1 d-flex">
								<v-text-field v-model="query.balanceFrom" label="余额>=" dense outlined></v-text-field>
								<v-text-field v-model="query.balanceTo" label="余额<=" dense outlined class="ml-1"></v-text-field>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>

							<v-btn @click="exportToExcel" :loading="exporting" :disabled="query.loading" color="primary" style="margin-left: 10px;">导出</v-btn>
							
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					<!-- <v-chip small :color="statusColor(item.status)">
					</v-chip> -->
					<span v-if="item.status=='0'" style="color:red">{{ statusName(item.status) }}</span>
					<span v-if="item.status=='1'">{{ statusName(item.status) }}</span>
				</template>
				<template v-slot:item.action="{item}">
					
					<v-menu top>
						<template v-slot:activator="{ attrs, on }">
							<v-btn v-bind="attrs" v-on="on" color="deep-purple lighten-3" small style="color: #424242;">
								操作
							</v-btn>
						</template>
						<v-list color="white" class="align-center">
							<v-list-item class="justify-center" v-if="item.status==='1'">
								<v-btn v-if="canRechargeCourse" @click.stop="showAddDialog(item)" color="deep-purple lighten-3" small style="color: #424242;">课时充值</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status==='1'">
								<v-btn @click.stop="showReduceDialog(item)" color="deep-purple lighten-3" small class="ml-1" style="color: #424242;">手工划课</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status=='1'">
								<v-btn  @click.stop="cancelAccount(item)" color="deep-purple lighten-3" small class="ml-1" style="color: #424242;">冻结账户</v-btn>
							</v-list-item>
							<v-list-item class="justify-center" v-if="item.status=='0'">
								<v-btn  @click.stop="openAccount(item)" color="deep-purple lighten-3" small class="ml-1" style="color: #424242;">启用账户</v-btn>
							</v-list-item>
							
							<v-list-item class="justify-center" v-if="item.status=='1'">
								<v-btn  @click.stop="showTransferDialog(item)" color="deep-purple lighten-3" small class="ml-1" style="color: #424242;">结转课时</v-btn>
							</v-list-item>
							
							<v-list-item class="justify-center">
								<v-btn @click.stop="showRefundDialog(item)" color="deep-purple lighten-3" small class="ml-1" style="color: #424242;">课程退费</v-btn>
							</v-list-item>
							
							<v-list-item class="justify-center">
								<v-btn @click.stop="showEditExpireDateDialog(item)" color="deep-purple lighten-3" small class="ml-1" style="color: #424242;">改有效期</v-btn>
							</v-list-item>
						</v-list>
					</v-menu>
					
				</template>
		
				<template v-slot:body.prepend="{ headers }">
					<tr class="account-summary-row">
						<td v-for="(header, index) in headers" :key="header.value">
							<span v-if="index === 0" title="当前筛选条件下的全部记录">全部合计</span>
							<span v-else>{{ summaryCells[header.value] }}</span>
						</td>
					</tr>
				</template>
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		

		<!-- 添加dialog -->
		<v-dialog title="课时充值" v-model="add.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title style="background-color:#9575CD; height: 55px;">
					<span style="color:#ffffff; font-size: 18px;" class="mt-n1">课时充值</span>
					<v-spacer></v-spacer>
					<v-icon color="white" @click="add.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet class="dark pa-4 rounded">
						<v-row dense>
							<v-col cols="12" class="mb-4">
								<span style="color:red; font-size: 16px;">注：只可用于"{{add.recharge.courseName}}"的消课,不可用于其他课程</span>
							</v-col>
							<v-col cols="6" class="pr-3">
									<v-text-field label="学号" disabled v-model="add.recharge.studentNo" dense
										outlined ></v-text-field>
								
							</v-col>
							<v-col cols="6" class="pr-3">
								<v-text-field label="姓名" disabled v-model="add.recharge.studentName" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3">
								<v-text-field label="课程名称" disabled v-model="add.recharge.courseName" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3">
								<v-text-field label="当前课时余额" v-model="add.recharge.balanceHour" disabled dense outlined>
								</v-text-field>
							</v-col>
							
							<v-col cols="6" class="mt-n3">
								<v-select :items="selectTeacherList" v-model="add.recharge.salesTeacherId" item-text="trueName"
									item-value="id" label="开单老师" dense outlined clearable></v-select>
							</v-col>
							<v-col cols="6" class="mt-n3">
								<v-select :items="selectTeacherList" v-model="add.recharge.classTeacherId" item-text="trueName"
									item-value="id" label="上课老师" dense outlined clearable></v-select>
							</v-col>
							
							<v-col cols="12" class="mt-n3">
								<v-select v-model="add.priceModel" :items="coursePriceList" label="价格套餐" item-text="viewText"
									item-value="id" return-object clearable outlined dense @change="priceChanged" no-data-text="暂无套餐数据"></v-select>
							</v-col>
							
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="课程原价"  v-model="add.recharge.courseAmount"  type="number" dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="增加课时数"  v-model="add.recharge.addHour" :rules="[rules.required,rules.int]" dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-select label="请选择优惠券" v-model="add.selectedCoupon" 
								:items="studentCouponItems" item-text="couponName" item-value="id" 
								no-data-text="没有可用优惠券"
								return-object clearable :disabled="!add.recharge.courseAmount"
								dense outlined @change="courseCouponChanged"></v-select>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="优惠券金额" v-model="couponAmount" disabled dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
								<v-text-field label="减免金额"  v-model="add.recharge.reduceAmount" type="number" dense outlined>
								</v-text-field>
							</v-col>
							<v-col cols="6" class="pr-3 mt-n3">
							<!-- 	<v-text-field label="实付金额" v-model="realPayFee" disabled type="number" dense outlined>
								</v-text-field> -->
								<span class="mt-2">需付款金额:</span>
								<span style="color: red;" class="ml-2 mt-1 text-h6">{{realPayFee}}</span>
								<span class="mt-2 ml-1">元</span>
							</v-col>
							<v-col cols="4" class="pr-3 mt-n3">
								<v-select v-model="add.recharge.payType" :items="payTypeList" label="付款方式" item-text="text"
									item-value="code" clearable outlined dense no-data-text="暂无付款方式"></v-select>
							</v-col>
							<v-col cols="8" class="pr-3 mt-n3">
								<v-text-field label="备注" v-model="add.recharge.memo" dense outlined>
								</v-text-field>
							</v-col>
						</v-row>
					</v-sheet>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="add.dialog=false">取消</v-btn>
					<v-btn @click="submitAddRecharge" :disabled="add.submitting" :loading="add.submitting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 扣除dialog -->
		<v-dialog title="扣除课时" v-model="reduce.dialog" max-width="600" persistent>
			<v-card>
				<!-- <v-card-title></v-card-title> -->
				<v-card-title style="background-color:#9575CD; height: 55px;">
					<span style="color:#ffffff; font-size: 18px;" class="mt-n1">活动划课</span>
					<v-spacer></v-spacer>
					<v-icon color="white" @click="reduce.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet class="dark pa-4 rounded">
						<v-row dense>
							<v-col cols="12" class="mb-4">
								<span style="color:red; font-size: 16px;">注：适用于正常消课外的活动划课,本操作会计入财务收入报表</span>
							</v-col>
							<v-col cols="6">
								<v-text-field label="学号" disabled v-model="reduce.order.studentNo" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="姓名" disabled v-model="reduce.order.studentName" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="课程名称" disabled v-model="reduce.order.courseName" dense
									outlined></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="当前课时余额" v-model="reduce.order.balanceHour" disabled dense outlined>
								</v-text-field>
							</v-col>
						
							<v-col cols="6">
								<v-text-field label="扣除课时数" type="number" v-model="reduce.order.reduceHour" dense outlined>
								</v-text-field>
							</v-col>
							
							<v-col cols="6">
								<v-text-field label="备注" v-model="reduce.order.memo" dense outlined>
								</v-text-field>
							</v-col>
						</v-row>
					</v-sheet>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="reduce.dialog=false">取消</v-btn>
					<v-btn @click="submitReduceHour" :disabled="reduce.submitting" :loading="reduce.submitting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 课程退费组件 -->
		<courseAccountRefund :show="refund.show" :account="refund.account" @cancel="refund.show=false" @success="refundSuccess"></courseAccountRefund>
		
		<!-- 课时结转 -->
		<courseAccountTransfer :show="transfer.show" :account="transfer.account" @cancel="transfer.show=false" @success="transferSuccess"></courseAccountTransfer>
		
		<!-- 改有效期 -->
		<editAccountExpire :show="expireDialog.show" :account="expireDialog.account" @cancel="expireDialog.show=false" @success="editExpireSuccess"></editAccountExpire>
		
	</v-card>
</template>

<script>
	import global from '../../../config/global'
	import utils from "../../../config/utils"
	import courseAccountRefund from "../../../components/course_account_refund.vue"
	import courseAccountTransfer from "../../../components/course_account_transfer.vue"
	import studentSearchBox from "../../../components/student_search_box.vue"
	import editAccountExpire from "../../../components/edit_account_expire.vue"
	import debounce from "../../../config/debounce.js"
	import * as XLSX from "xlsx";
	export default {
		name: "student-account-list",
		components:{courseAccountRefund,courseAccountTransfer,studentSearchBox,editAccountExpire},
		data() {
			return {
				canRechargeCourse: false,
				rules: {
					required: value => !!value || '不能为空',
					int: value => {
						const pattern = /^(0|[1-9][0-9]*)$/;
						return pattern.test(value) || '只能输入0或正整数'
					},
				},
				imgPrev: global.config.imgPre,
				data: {
					total: 0,
					headers: [
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '学号',
							value: 'studentNo',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '总课程价值',
							value: 'totalTuitionFee',
							sortable: false
						},
						{
							text: '总实付金额',
							value: 'realPayFee',
							sortable: false
						},
						{
							text: '已用金额',
							value: 'usedFee',
							sortable: false
						},
						{
							text: '剩余金额',
							value: 'balanceFee',
							sortable: false
						},
						{
							text: '总课时数',
							value: 'totalClassHour',
							sortable: false
						},
						{
							text: '已用课时',
							value: 'usedClassHour',
							sortable: false
						},
						{
							text: '剩余课时',
							value: 'balanceHour',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '到期日期',
							value: 'expireDate',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list: [],
					summary: null,
				},
				listRequestId: 0,
				exporting: false,
				selectShopList: [], //选择门店数据源
				selectCourseList: [], //选择课程数据源
				studentCouponItems:[],
				coursePriceList:[], // 课程价格套餐
				selectTeacherList: [], //选择老师数据源
				payTypeList:[
					{code:'ALIPAY',text:'支付宝'},
					{code:'WXPAY',text:'微信'},
					{code:'CASH',text:'现金'},
				],
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "正常"
					},
					{
						id: "0",
						statusName: "作废"
					},
				],

				query: {
					loading: false,
					page: 1,
					size: 20,
					courseId: "",
					studentNo: "",
					studentName: "",
					status: "1",
					balanceFrom:"",
					balanceTo:""
				},
				add: {
					dialog: false,
					submitting: false,
					selectedCoupon:null, //选择的优惠券
					priceModel:null,
					
					recharge: {
						accountId: "", // 账号ID
						studentNo: "",
						studentName: "",
						courseName: "", 	// 课程名称
						balanceHour:"", 	// 当前余额
						courseAmount: "", 	// 课程金额
						addHour:"",			// 增加课时数
						memo:"", 			// 备注
						reduceAmount:"", 	// 减免金额
						payType:'', // 支付方式
						salesTeacherId:"",
						classTeacherId:""
					},
				},
				reduce:{
					dialog:false,
					submitting:false,
					order:{
						accountId: "", // 账号ID
						studentNo: "",
						studentName: "",
						courseName: "", // 课程名称
						balanceHour:"", // 当前余额
						reduceHour:"",	// 扣课时数
						memo:"", //备注
					}
				},
				refund:{
					show:false,
					account:null
				},
				transfer:{
					show:false,
					account:null
				},
				expireDialog:{
					show:false,
					account:null
				}
				
				
			}
		},
		created() {
			this.axios.get('/financial/access').then(({ data }) => {
				this.canRechargeCourse = data.code === 200 && !!data.data && data.data.rechargeCourse === true;
			}).catch(() => { this.canRechargeCourse = false; });
			// 获取门店列表
			this.getCourseListForSelect();
			this.getTableDataList();
			this.getTeacherListForSelect();
			
		},
		mounted(){
			
		},
		computed:{
			summaryCells(){
				const cells = {};
				const moneyFields = ['totalTuitionFee', 'realPayFee', 'usedFee', 'balanceFee'];
				const hourFields = ['totalClassHour', 'usedClassHour', 'balanceHour'];
				moneyFields.concat(hourFields).forEach(field => {
					const value = this.data.summary && this.data.summary[field];
					if (this.query.loading || value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) {
						cells[field] = '—';
					} else {
						cells[field] = moneyFields.includes(field) ? Number(value).toFixed(2) : String(value);
					}
				});
				return cells;
			},
			realPayFee(){
				if(!this.add.recharge.courseAmount){
					return "0";
				}
				// 原价
				let courseAmount = parseFloat(this.add.recharge.courseAmount);
				// 优惠券金额
				let couponAmount = 0;
				if (this.add.selectedCoupon){
					couponAmount = parseFloat(this.add.selectedCoupon.amount);
				}
				// 减免金额
				let reduceAmount = 0;
				if (this.add.recharge.reduceAmount){
					reduceAmount = parseFloat(this.add.recharge.reduceAmount);
				}
				let result = courseAmount - couponAmount - reduceAmount;
				result = result.toFixed(2);
				return result > 0 ? result:0 ;
			},
			couponAmount(){
				if(!this.add.selectedCoupon){
					return "0";
				}
				
				return this.add.selectedCoupon.amount;
			},
			
			
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			queryShopChanged() {

				if (this.query.shopId) {
					this.getCourseListForSelect(this.query.shopId);
				}
			},
			setInputValue(value){
				// 搜索框输入的值
			
				this.query.studentName = value;
			},
			courseCouponChanged(e){
			
				// 课时 优惠券选择
				let limitAmount = parseFloat(e.limitAmount);
				const cashAmount = parseFloat(this.add.recharge.courseAmount);
				if (limitAmount > 0){
					// 有金额限制 判断金额限制
					if (cashAmount < limitAmount){
						// 不符合
						
						this.$noty.error('优惠券需满'+limitAmount+'元才能使用');
						const that = this;
						setTimeout(()=>{
							that.add.selectedCoupon = null;
						},100)
					}
				}
				
			},
			priceChanged(e){
				console.log(e);
				if (e){
					this.add.recharge.courseAmount = e.courseAmount;
					this.add.recharge.addHour = e.addHours;
					this.add.recharge.reduceAmount = e.reduceAmount;
				}else {
					this.add.recharge.courseAmount = "";
					this.add.recharge.addHour = "";
					this.add.recharge.reduceAmount = "";
				}
			},
			
			showAddDialog(item) {
				if (!this.canRechargeCourse) return;
				this.add.dialog = true;

				this.add.recharge.accountId = item.id;
				this.add.recharge.studentNo = item.studentNo;
				this.add.recharge.studentName = item.studentName;
				this.add.recharge.courseName = item.courseName;
				this.add.recharge.balanceHour = item.balanceHour;
				this.add.recharge.salesTeacherId = "";
				this.add.recharge.classTeacherId = "";
			
				
				// 获取学员优惠券
				this.add.selectedCoupon = null;
				this.getStudentCouponListForSelect(item.studentId);
				
				// 获取课时价格套餐
				this.add.priceModel = null;
				this.getCoursePriceListForSelect(item.courseId);
				
			},
			showReduceDialog(item){
				// 扣课时
				this.reduce.dialog = true;
				
				
				this.reduce.order.accountId = item.id;
				this.reduce.order.studentNo = item.studentNo;
				this.reduce.order.studentName = item.studentName;
				this.reduce.order.courseName = item.courseName;
				this.reduce.order.balanceHour = item.balanceHour;
			},
			submitAddRecharge(){
				if (!this.canRechargeCourse) return;
				// 提交充值
				if(!this.add.recharge.courseAmount){
					this.$noty.error("请输入课程金额")
					return
				}
				if (!utils.isDecimal(this.add.recharge.courseAmount)){
					this.$noty.error("课程金额格式错误,最多2位小数的正数")
					return
				}
				
				
				if (!this.add.recharge.addHour){
					this.$noty.error("请输入增加的课时")
					return
				}
				
				const pattern = /^(0|[1-9][0-9]*)$/;
				if( pattern.test(this.add.recharge.addHour) == false ){
					this.$noty.error("课时格式错误")
					return
				}
				
				if (this.add.recharge.reduceAmount) {
					if (!utils.isDecimal(this.add.recharge.reduceAmount)){
						this.$noty.error("直减金额格式错误,最多2位小数的正数")
						return
					}
				}
				
				this.add.submitting = true;
				
				// api
				const that = this;
				let url = `/financial/student/account/recharge`;
				let postData = {
					accountId:this.add.recharge.accountId,
					courseAmount :this.add.recharge.courseAmount,
					addHour: this.add.recharge.addHour,
					memo:this.add.recharge.memo,
					reduceAmount:this.add.recharge.reduceAmount,
					payType:this.add.recharge.payType,
					salesTeacherId:this.add.recharge.salesTeacherId,
					classTeacherId:this.add.recharge.classTeacherId
				}
				// 选择了优惠券
				if(this.add.selectedCoupon){
					postData.studentCouponId = this.add.selectedCoupon.id;
				}
				// 选择了套餐
				if(this.add.priceModel){
					postData.priceId = this.add.priceModel.id;
				}
				
				console.log('post',postData);
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							that.add.submitting = false;
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			submitReduceHour(){
				// 扣除课时提交
				if (!this.reduce.order.reduceHour){
					this.$noty.error("请输入扣除的课时")
					return
				}
				
				if (!utils.isInt(this.reduce.order.reduceHour)){
					this.$noty.error("课时格式错误,只能是正整数")
					return
				}
				
				
				this.reduce.submitting = true;
				
				// api
				const that = this;
				let url = `/financial/student/account/reduce`;
				let postData = {
					accountId:this.reduce.order.accountId,
					reduceHour: this.reduce.order.reduceHour,
					memo:this.reduce.order.memo,
				}
			
				console.log("reduce postdata");
				console.log(postData);
				
				this.axios.post(url, postData).catch(() => {
					that.reduce.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("扣除成功");
							that.getTableDataList();
							that.reduce.dialog = false;
							that.reduce.submitting = false;
							return;
						} else {
							that.reduce.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.reduce.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			showRefundDialog(item){
				// 显示退费组件
				console.log(item);
				this.refund.account = item;
				this.refund.show = true;
			},
			showEditExpireDateDialog(item){
				console.log(item)
				//显示修改有效期组件
				this.expireDialog.account = item;
				this.expireDialog.show = true;
			},
			refundSuccess(){
				//  退费成功
				this.getTableDataList();
				this.refund.show=false;
			},
			showTransferDialog(item){
				// 显示课时结转组件
				this.transfer.account = item;
				this.transfer.show = true;
			},
			transferSuccess(){
				//  结转成功
				this.getTableDataList();
				this.transfer.show=false;
			},
			editExpireSuccess(){
				// 修改成功
				this.getTableDataList();
				this.expireDialog.show=false;
			},
			getTableDataList() {
				
				if(this.query.balanceFrom){
					if(!utils.isInt(this.query.balanceFrom)){
						this.$noty.error('余额请输入正整数');
						return
					}
				}
				
				if(this.query.balanceTo){
					if(!utils.isInt(this.query.balanceTo)){
						this.$noty.error('余额请输入正整数');
						return
					}
				}
				
				if (this.query.balanceFrom !== '' && this.query.balanceTo !== '' && Number(this.query.balanceFrom) > Number(this.query.balanceTo)) {
					this.$noty.error('余额下限不能大于上限');
					return;
				}

				const requestId = ++this.listRequestId;
				this.query.loading = true;
				this.data.summary = null;
				const params = { shopId: utils.getCurrentShopId() };
				['courseId', 'studentNo', 'studentName', 'status', 'balanceFrom', 'balanceTo'].forEach(key => {
					const value = this.query[key];
					if (value !== '' && value !== null && value !== undefined) {
						params[key] = value;
					}
				});
				const url = `/financial/student/account/list/page/${this.query.page - 1}/size/${this.query.size}`;
				return this.axios.get(url, { params }).then(response => {
					if (requestId !== this.listRequestId) return;
					if (response.data.code !== 200) {
						throw new Error(response.data.message || '获取失败');
					}
					const pageData = response.data.data;
					this.data.list = pageData.list || [];
					this.data.total = pageData.count;
					this.data.summary = pageData.summary || null;
				}).catch(error => {
					if (requestId !== this.listRequestId) return;
					this.data.list = [];
					this.data.total = 0;
					this.data.summary = null;
					this.$noty.error('获取失败：' + ((error && error.message) || '网络请求失败'));
				}).finally(() => {
					if (requestId === this.listRequestId) this.query.loading = false;
				});
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			cancelAccount(item){
				// 作废课时账户
				const accountId = item.id;
				const that = this;
				let url = `/financial/course/account/cancel/` + accountId;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.getTableDataList();
						return
					}
				
					that.$noty.error("操作失败：" + response.data["message"]);
				})
			},
			openAccount(item){
				// 作废课时账户
				const accountId = item.id;
				const that = this;
				let url = `/financial/course/account/open/` + accountId;
				
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.getTableDataList();
						return
					}
				
					that.$noty.error("操作失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect() {
				
				const shopId = utils.getCurrentShopId();
				
				if (!shopId) {
					return
				}
				const that = this;
				let url = `/edu/shop/course/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect() {
			
				const shopId = utils.getCurrentShopId();
				
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getStudentCouponListForSelect(studentId) {
			
				if (!studentId) {
					return
				}
				const that = this;
				let url = `/financial/student/all/coupon/list/` + studentId;
			
				this.axios.get(url).then(response => {
					
					console.log("student coupon:",response);
					if (response.data["code"] === 200) {
						that.studentCouponItems = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCoursePriceListForSelect(courseId) {
				// 获取课程价格套餐
				if (!courseId) {
					return
				}
				
				const that = this;
				let url = `/financial/course/${courseId}/available/price/list`;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.coursePriceList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			async exportToExcel(){
				if (this.exporting) return;
				for (const key of ['balanceFrom', 'balanceTo']) {
					const value = this.query[key];
					if (value !== '' && value != null && !utils.isInt(value)) {
						this.$noty.error('余额请输入非负整数');
						return;
					}
				}
				if (this.query.balanceFrom !== '' && this.query.balanceTo !== '' && Number(this.query.balanceFrom) > Number(this.query.balanceTo)) {
					this.$noty.error('余额下限不能大于上限');
					return;
				}
				// 固定本次导出的筛选条件，分页取完全部明细。
				const params = { shopId: utils.getCurrentShopId() };
				['courseId', 'studentNo', 'studentName', 'status', 'balanceFrom', 'balanceTo'].forEach(key => {
					const value = this.query[key];
					if (value !== '' && value != null) params[key] = value;
				});
				this.exporting = true;
				try {
					const rows = [];
					let total, summary;
					for (let page = 0; ; page++) {
						const response = await this.axios.get('/financial/student/account/list/page/' + page + '/size/1000', { params });
						if (response.data.code !== 200) throw new Error(response.data.message || '获取失败');
						const data = response.data.data;
						if (page === 0) {
							total = Number(data.count);
							summary = data.summary;
						}
						if (!Number.isSafeInteger(total) || total < 0 || Number(data.count) !== total) throw new Error('数据发生变化，请重新导出');
						rows.push(...(data.list || []));
						if (rows.length === total) break;
						if (!data.list || !data.list.length || rows.length > total) throw new Error('明细不完整，请重新导出');
					}
					const columns = this.data.headers.filter(header => header.value !== 'action');
					const moneyFields = ['totalTuitionFee', 'realPayFee', 'usedFee', 'balanceFee'];
					const numberFields = moneyFields.concat(['totalClassHour', 'usedClassHour', 'balanceHour']);
					const numericValue = value => {
						if (value === '' || value == null || !Number.isFinite(Number(value))) throw new Error('金额或课时数据不完整，无法导出');
						return Number(value);
					};
					const sheetRows = [columns.map(header => header.text)];
					rows.forEach(row => sheetRows.push(columns.map(({ value }) => {
						if (numberFields.includes(value)) return numericValue(row[value]);
						if (value === 'status') return this.statusName(row.status);
						return row[value] == null ? '' : String(row[value]);
					})));
					sheetRows.push(columns.map(({ value }, index) => {
						if (index === 0) return '全部合计';
						return numberFields.includes(value) ? numericValue(summary && summary[value]) : '';
					}));
					const sheet = XLSX.utils.aoa_to_sheet(sheetRows);
					columns.forEach(({ value }, column) => {
						if (!numberFields.includes(value)) return;
						for (let row = 1; row < sheetRows.length; row++) {
							sheet[XLSX.utils.encode_cell({ r: row, c: column })].z = moneyFields.includes(value) ? '0.00' : '0';
						}
					});
					sheet['!cols'] = columns.map(({ value }) => ({ wch: value === 'courseName' ? 24 : 16 }));
					const workbook = XLSX.utils.book_new();
					XLSX.utils.book_append_sheet(workbook, sheet, '课时账户余额');
					XLSX.writeFile(workbook, '课时导出列表.xlsx');
					this.$noty.success('导出成功');
				} catch (error) {
					this.$noty.error('导出失败：' + ((error && error.message) || '网络请求失败'));
				} finally {
					this.exporting = false;
				}
			}
		}
	}
</script>

<style scoped>
	.account-summary-row {
		background-color: #ede7f6;
		font-weight: 600;
	}
	.account-summary-row td {
		white-space: nowrap;
		border-top: 2px solid #b39ddb;
	}
	.studentResult{
		position: absolute;
		top:-26px;
		left:0;
		list-style: none;
		background-color: lightblue;
		width: 180px;
		max-height:200px;
		overflow: hidden auto;
		border-radius: 10px;
	}
	.studentResult li{
		display:block;
		height:30px;
		line-height: 30px;
		cursor: pointer;
	}
</style>
